import { tokenize } from "../../lib/utils/helper/tokenMatcher";
import * as fuzzball from 'fuzzball';

const getTextToHighlight = (spanElements, searchText) => {
  const TOKEN_SEPARATOR = ' ';

  const searchTextTokens = tokenize(searchText);
  const maxSearchWindow = searchTextTokens.length * 3;
  const minSearchWindow = Math.max(1, Math.floor(searchTextTokens.length / 2));
  const allSpanElementTokens = [];

  for (const spanIdx of Object.keys(spanElements)) {
    const spanElement = spanElements[spanIdx];
    const spanElementTokens = tokenize(spanElement.textContent);

    spanElementTokens.forEach((token) => {
      token.spanElement = spanElement;
      token.globalTokenIndex = allSpanElementTokens.length;
      allSpanElementTokens.push(token);
    });
  }

  const normalizedSearchStr = fuzzball.full_process(searchTextTokens.map(m => m.token).join(TOKEN_SEPARATOR));
  let bestLeft = 0;
  let bestRight = allSpanElementTokens.length;
  let bestScore = 0;
  let foundAnything = false;
  const allSearchTokensSet = new Set(searchTextTokens.map(t => t.token));

  for (let searchWindow = maxSearchWindow; searchWindow >= minSearchWindow; searchWindow--) {
    let foundBetter = false;
    let bestLeftCandidate = bestLeft;
    let bestRightCandidate = bestRight;

    for (let i = bestLeft; i < bestRight - searchWindow + 1; i++) {
      const currentTokens = allSpanElementTokens.slice(i, i + searchWindow).map(t => t.token);
      const currentStr = currentTokens.join(TOKEN_SEPARATOR);
      const currentTokensSet = new Set(currentTokens);
      const foundSearchTokens = allSearchTokensSet.intersection(currentTokensSet);
      const tokenMatchRatio = foundSearchTokens.size / searchTextTokens.length;
      const score = fuzzball.ratio(normalizedSearchStr, currentStr) * tokenMatchRatio;

      if (score > bestScore) {
        bestScore = score;
        bestLeftCandidate = i;
        bestRightCandidate = i + searchWindow;
        foundBetter = true;
      }
    }

    if (foundBetter) {
      bestLeft = bestLeftCandidate;
      bestRight = bestRightCandidate;
      foundAnything = true;
    }
  }

  if (!foundAnything) return [];
  const longestSequence = allSpanElementTokens.slice(bestLeft, bestRight);

  return longestSequence;
};

const highlightText = async (textToHighlight = {}) => {
  if (!textToHighlight.length) return;
  const groupedBySpan = new Map();
  
  textToHighlight.forEach(token => {
    const spanElement = token.spanElement;

    if (!groupedBySpan.has(spanElement)) {
      groupedBySpan.set(spanElement, []);
    }

    groupedBySpan.get(spanElement).push(token);
  });
  
  for (const [spanElement, tokens] of groupedBySpan) {
    if (!spanElement || !tokens.length) continue;
    // add <mark> to the first and </mark> to the last character of the span element
    const start = tokens[0].index;
    const end = tokens.at(-1).endIndex;
    const result =
      spanElement.textContent.slice(0, start) +
      `<mark>${spanElement.textContent.slice(start, end)}</mark>` +
      spanElement.textContent.slice(end);
    spanElement.innerHTML = result;
  }
};

export { getTextToHighlight, highlightText };
